/**
 * Create store system divecePatch - softwarePatch
 * 시스템 > 패치 관리 > 장비 관리 > 소프트웨어 패치
 *
 * @since 2018-11-05
 * @author devp018
 * @modify jupil.Go <devp018>
 */

import {CommonApiPrefix as cmnApiPrefix, SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  apiUrl: {
    filePatch: `${apiPrefix}/patch/device/sw-patch`, // 장비 소프트웨어 패치 - 파일 API
    onlinePatch: `${apiPrefix}/patch/device/sw-patch-online`, // 장비 소프트웨어 패치 - 온라인 API
    patchDate: `${apiPrefix}/patch/device/sw-patch-date`, // 날짜별 패치 내역 조회 API
    patchDevice: `${apiPrefix}/patch/device/sw-patch-device` // 장비별 패치 내역 조회 API
  },
  patchHistoryList: [], // 날짜별 패치 내역
  patchHistoryDetailList: [], // 날짜별 패치 상세 내역
  devicePatchHistoryList: [], // 장비별 패치 내역
  devicePatchHistoryDetailList: [], // 장비별 패치 상세 내역
  updateType: {
    type: 'FILE'
  }, // 'FILE' or 'ONLINE'
  deviceIdList: [], // 장비 목록
  upLoadFile: void 0,
  originalFile: void 0,
  showRefresh: true,
  errorMessage: null
})

export const mutations = {
  setErrorMessage (state, data) {
    state.errorMessage = data.msg || ''
  },
  setRefreshFlag (state, data) {
    state.showRefresh = data
  },
  clearPatchHistoryData (state) {
    state.patchHistoryList = []
    state.patchHistoryDetailList = []
    state.devicePatchHistoryList = []
    state.devicePatchHistoryDetailList = []
  },
  // 날짜별 패치 내역 설정
  setPatchHistoryList (state, data) {
    state.patchHistoryList = _.cloneDeep(data)
  },
  // 날짜별 패치 상세 내역 설정
  setPatchHistoryDetailList (state, data) {
    state.patchHistoryDetailList = _.cloneDeep(data)
  },
  setDevicePatchHistoryList (state, data) {
    state.devicePatchHistoryList = _.cloneDeep(data)
  },
  setDevicePatchHistoryDetailList (state, data) {
    state.devicePatchHistoryDetailList = _.cloneDeep(data)
  },
  // setUpdateType (state, type) {
  //   state.updateType = type
  // },
  clearPatchDeviceData (state, clear = true) {
    state.updateType = {
      type: 'FILE'
    }
    state.deviceIdList = []
    if (clear) {
      state.upLoadFile = void 0
    }
  },
  // 패치 대상 장비 목록 설정
  setPatchDeviceData (state, data) {
    state.deviceIdList = _.cloneDeep(data)
  },
  // 파일 업로드
  fileUpload (state, data) {
    state.upLoadFile = data.file
    state.originalFile = data.original_file
  }
}

export const actions = {
  // 날짜별 패치 내역 조회
  // type : 패치 현황 구분 타입 (1: 날짜별 패치 현황, 2: 장비별 패치 현황)
  async getPatchHistoryList ({commit, state}, {type}) {
    const url = type === 1 ? state.apiUrl.patchDate : state.apiUrl.patchDevice

    const {code, result} = await this.$axios.$get(url, {loading: state.showRefresh})
    if (code === 'ok') {
      if (type === 1) {
        commit('setPatchHistoryList', result)
      } else {
        commit('setDevicePatchHistoryList', result)
      }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 날짜별 패치 상세 내역 조회
  // type : 패치 현황 구분 타입 (1: 날짜별 패치 현황, 2: 장비별 패치 현황)
  async getPatchHistoryDetailList ({commit, state}, {deviceId, type}) {
    let url = type === 1 ? state.apiUrl.patchDate : state.apiUrl.patchDevice
    url += `/${deviceId}`

    const {code, result} = await this.$axios.$get(url, {loading: false})
    if (code === 'ok') {
      if (type === 1) {
        commit('setPatchHistoryDetailList', result)
      } else {
        commit('setDevicePatchHistoryDetailList', result)
      }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 파일 업로드
  async fileUpload ({commit}, {formData}) {
    const {code, result} = await this.$axios.$post(`${cmnApiPrefix}/file/import`, formData)

    if (code === 'ok') {
      commit('fileUpload', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 장비 소프트웨어 패치 - 파일/온라인
  async setDevicePatchData ({commit, state}) {
    let data = { code: 'nok', result: { msg: `Unknown Update Type: ${state.updateType.type}` } }
    if (state.updateType.type === 'FILE') {
      data = await this.$axios.$post(state.apiUrl.filePatch, { device_list: state.deviceIdList, file_name: `${state.upLoadFile}`, original_file: `${state.originalFile}` })
    } else if (state.updateType.type === 'ONLINE') {
      data = await this.$axios.$post(state.apiUrl.onlinePatch, { device_list: state.deviceIdList })
    }

    if (data.code === 'ok') {
      return true
    }
    commit('setErrorMessage', data.result)
    return false
  }
}

export const getters = {
}

export const strict = false
